import { fromJS } from 'immutable'
import {
  COMPANY_CREATE_REQUEST,
  COMPANY_CREATE_SUCCESS,
  COMPANY_CREATE_FAILURE,
  COMPANY_CREATE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case COMPANY_CREATE_REQUEST:
      return state
        .set('isFetching', true)
    case COMPANY_CREATE_SUCCESS:
      return state
        .set('companyCreate', fromJS(action.payload.createdCompany))
        .set('status', 200)
        .set('message', 'Created Successfully.')
        .set('isFetching', false)
    case COMPANY_CREATE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('companyCreate', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case COMPANY_CREATE_RESET:
      return state
        .delete('companyCreate')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/company/company-create-reducer.js